import request from 'tools/request'

/**
 * Fetch broker application dashboard data
 * @param {Object} params - Query parameters (dateRange, brokerIds)
 * @returns {Promise} API response
 */
export const getBrokerApplicationDashboard = (demoMode, query) => async () => {
    const res = await request(
        `broker-portal/stats`, 
        'GET', 
        null,
        true,
        { 'x-demo-mode': demoMode },
        query
    )
    return res
}

/**
 * Fetch list of brokers for the multi-select dropdown
 * @returns {Promise} API response with broker list
 */
export const getBrokersList = async () => {
    const res = await request(
        'broker-portal/brokers',
        'GET'
    )
    return res
}
